export default __webpack_public_path__ + "static/media/du-logo.1d779b1d.png";